module.exports = __webpack_public_path__ + "dfb7b60f72c353b9fd5a68d3daca3db6.png";